import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { useSEO } from "../lib/useSEO";
import { Container, SectionHeading, CTAButton, Reveal } from "../components/site/ui";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../components/ui/accordion";

export default function UseCases() {
  const { t, lang } = useLang();
  const u = t.useCases;
  useSEO({ title: u.metaTitle, description: u.metaDesc, path: "/use-cases", lang });

  return (
    <div>
      <section className="pt-28 pb-16 border-b border-cool-dark" data-testid="usecases-hero">
        <Container><SectionHeading eyebrow={u.eyebrow} title={u.title} intro={u.intro} /></Container>
      </section>

      <section className="py-16" data-testid="usecases-list">
        <Container>
          <Accordion type="single" collapsible defaultValue="uc-0" className="border-t border-cool-dark">
            {u.items.map((item, i) => (
              <AccordionItem key={i} value={`uc-${i}`} className="border-b border-cool-dark">
                <AccordionTrigger className="py-6 hover:no-underline text-left" data-testid={`usecase-trigger-${i}`}>
                  <span className="flex items-center gap-4">
                    <span className="font-mono text-xs text-cyan">{String(i + 1).padStart(2, "0")}</span>
                    <span className="font-display text-lg md:text-xl text-white text-left">{item.t}</span>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-8" data-testid={`usecase-content-${i}`}>
                  <div className="grid md:grid-cols-3 gap-px bg-cool-dark border border-cool-dark md:ml-10">
                    <div className="bg-nb-base p-5">
                      <div className="eyebrow mb-2">{u.labels.problem}</div>
                      <p className="text-sm text-cool-light leading-relaxed">{item.problem}</p>
                    </div>
                    <div className="bg-nb-base p-5">
                      <div className="eyebrow mb-2">{u.labels.decision}</div>
                      <p className="text-sm text-white leading-relaxed">{item.decision}</p>
                    </div>
                    <div className="bg-nb-base p-5">
                      <div className="eyebrow mb-2" style={{ color: "#D4AF37" }}>{u.labels.kpi}</div>
                      <p className="text-sm text-cool-light leading-relaxed">{item.kpi}</p>
                    </div>
                  </div>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
          <Reveal className="mt-14"><CTAButton to="/contact" variant="primary" testId="usecases-cta">{t.common.talkUseCase}</CTAButton></Reveal>
        </Container>
      </section>
    </div>
  );
}
